<template src="./template/modal-damage-marking.html"></template>
<script>

import DibbleJS from "@/dibble";
import $ from 'jquery'

export default {
    name: "ModalDamageMarking",
    components: {

    },
    props: {
        checkoutMarkingsList: {
            type: Array
        },
        status: String
    },
    data() {
        return {
            currentUpdateStatus: null,
            positionName: null,
            mainImage: null,
            mainImageWidth: 0,
            markers: []
        };
    },
    created() {
        this.$parent.$on('setCurrentMarkerImage', data => {
            this.currentUpdateStatus = data['status']
            this.markers = []
            const item = this.checkoutMarkingsList.find(innerItem => innerItem['name'] === data['image'])
            if (typeof item === 'undefined') {
                DibbleJS.toastErrorMessage('Marking image is not existed.')
                this.closeModal()
            }

            this.positionName = item['name']
            this.mainImage = item['image_url']
            this.markers = item['markers']
        })
      console.log('markingList', this.checkoutMarkingsList)
    },
    methods: {
        getMainPhotoSize() {
            this.mainImageWidth = $('img#markerMainImage').width()
        },
        addMarker(event) {
            this.markers.push({
                id: Math.random(),
                x: event.offsetX + 10,
                y: event.offsetY - 10
            })

            this._saveMarkers()
        },
        removeMarker(id) {
            this.markers = this.markers.filter(item => item.id !== id)
            this._saveMarkers()
        },
        clearMarkers() {
            this.markers = []
            this._saveMarkers()
        },
        _saveMarkers() {
            this.$emit('setMarker', {
                image: this.mainImage,
                display_image_width: this.mainImageWidth,
                markers: this.markers
            })
        },
        closeModal() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss">
    .main-image-marker {
        max-height: 600px;
    }
</style>
